import Vue from 'vue'
import toastr from '../toastr'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import VueResource from 'vue-resource'
import mixins from '../mixins.js'
import servingMixins from '../mixins/serving-mixins'
import TextInput from '../../component/dccore-form/textInput.vue'
import NumberInput from '../../component/dccore-form/numberInput.vue'
import Multiselect from '../../component/dccore-form/multiselect.vue'
import Singleselect from '../../component/dccore-form/singleselect.vue'
import SimpleSingleselect from '../../component/singleselect.vue'
import SimpleNumberInput from '../../component/simple-form/numberInput.vue'
import multimedia from '../../component/dccore-form/multimedia.vue'

if ($('#serving_component_form').length) {
  Vue.use(VueResource)

  new Vue({
    el: '#serving_component_form',
    components: {
      TextInput,
      Singleselect,
      Multiselect,
      RingLoader,
      NumberInput,
      SimpleSingleselect,
      SimpleNumberInput,
      multimedia
    },
    mixins: [mixins, servingMixins],
    data: {
      loading: 0,
      multimedia: [],
      entityId: null,
      sumWeight: 0,
      form: {
        entity: {
          servingGrammages: [],
          meal: null,
        },
        options: {
          errors: {},
          meals: [],
        }
      },
      portions: [],
      hasErrors: false,
      hasAllComponentServings: true,
      subcomponentsMeals : [],
      quantityServingGrammages : {},
    },
    watch: {
      'form.entity.meal': {
        handler: function (val) {
          if (val > 0) {
            if (!this.entityId) {
              this.form.entity.servingGrammages = []
            }
            this.getUnitFromMeal()
            this.getServingGrammages(!this.entityId)

            this.calculateWeight()
          }
        },
      }
    },
    mounted() {
      if ($('#entity_id').length) {
        this.entityId = $('#entity_id').val()
        this.getServing()
      } else {
        this.getComponentMeals()
      }
    },
    methods: {
      createServing(redirect) {
        if (!this.hasAllComponentServings) {
          toastr.error(Translator.trans('serving.errors.not_fill_component_meals'))
          return
        }

        if (this.checkDuplicateServing()) {
          toastr.error(Translator.trans('serving.errors.duplicate_serving'))
          return
        }

        if (!this.$refs.errorChecker.errorCheck()) {
          let url = Routing.generate('api_post_serving_component')
          this.form.entity.type = 'component'

          let data = {
            data: this.form.entity,
            multimedia: this.multimedia,
          }
          this.loading++
          this.$http.post(url, data).then(() => {

            if (redirect) {
              toastr.success(Translator.trans('form.created'))
              $(location).attr('href', Routing.generate('serving_grid'))
            } else {
              toastr.success(Translator.trans('form.created'))
              this.form.options.errors = {}
            }
            this.loading--
          }, response => {
            this.handleAjaxError(response, this.form.options)
            this.loading--
          })
        }
      },
      updateServing(redirect) {
        if (this.checkDuplicateServing()) {
          toastr.error(Translator.trans('serving.errors.duplicate_serving'))
          return
        }

        if (!this.$refs.errorChecker.errorCheck()) {
          let url = Routing.generate('api_patch_serving_component', {
            id: this.entityId,
          })

          let data = {
            data: this.form.entity,
            multimedia: this.multimedia,
          }
          this.loading++
          this.$http.patch(url, data).then(() => {
            if (redirect) {
              $(location).attr('href', Routing.generate('serving_grid'))
              this.loading--
            } else {
              this.form.entity.isCalorificCalculated = false
              this.refreshPrice(this.entityId).then(() => {
                toastr.success(Translator.trans('form.updated'))
                this.form.options.errors = {}
                this.loading--
              })
            }
          }, response => {
            this.handleAjaxError(response, this.form.options)
            this.loading--
          })
        }
      },
      getServing() {
        let url = Routing.generate('api_get_serving', { id: this.entityId,
          context: 'edit' })
        this.loading++
        this.$http.get(url).then(response => {
          this.form.entity = response.data.serving
          this.form.entity.servingGrammages = response.data.serving.selectedServingGrammages
          this.form.entity.meal = response.data.serving.selectedMeal
          if (this.form.entity.multimedia) {
            this.multimedia = this.form.entity.multimedia.collection

            delete this.form.entity.multimedia
          }
          this.getPortions(false)
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      getUnits() {
        let url = Routing.generate('api_get_materials_units')
        this.loading++
        Vue.http.get(url).then(response => {
          this.form.options.units = response.data
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      getUnitFromMeal() {
        let url = Routing.generate('api_get_meal_unit', { id : this.form.entity.meal })
        this.loading++
        Vue.http.get(url).then(response => {
          this.form.entity.unit = response.data
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },

      getComponentMeals() {
        this.loading++
        let url = Routing.generate('api_get_meals_by_kind', { context: 'dropdown',
          kind: 'component_meal' })
        this.$http.get(url).then(response => {
          this.form.options.meals = response.data

          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },

      getServingGrammages(updateServingGrammages) {
        this.loading++
        let url = Routing.generate('api_get_meals_subcomponent_meals', {
          id: this.form.entity.meal,
          context: 'serving'
        })
        this.$http.get(url).then(response => {
          this.subcomponentsMeals = response.data
          if (updateServingGrammages) {
            for (let i = 0; i < this.subcomponentsMeals.length; i++) {

              if (this.subcomponentsMeals[i].componentServings.length === 0) {

                this.form.options.errors = {
                  'meal': { 1: Translator.trans('serving.errors.not_fill_component_meals') },
                  'servingPackages' : [],
                }

                toastr.error(Translator.trans('serving.errors.not_fill_component_meals'))

                this.hasAllComponentServings = false
                this.form.entity.servingGrammages = []
                this.loading--

                return
              }

              const selectedCompoentServing = this.subcomponentsMeals[i].componentServings.length > 0 ?
                this.subcomponentsMeals[i].componentServings[0].id : null
              const selectedUnit = this.subcomponentsMeals[i].componentServings.length > 0 ?
                this.subcomponentsMeals[i].componentServings[0].unit : ''
              const selectedWeight = this.subcomponentsMeals[i].componentServings.length > 0 ?
                this.subcomponentsMeals[i].componentServings[0].weight : 0

              let tmpData = {
                componentServing: selectedCompoentServing,
                selectedComponentServing:  selectedCompoentServing,
                unit: selectedUnit,
                weight: selectedWeight,
                value: 0,
                servings: this.subcomponentsMeals[i].componentServings,
                type: 'component_meal',
                meal: this.subcomponentsMeals[i].id,
                ratio: 1,
              }
              this.form.entity.servingGrammages.push(tmpData)
            }

            this.form.options.errors = {
              servingPackages:[]
            }
            this.hasAllComponentServings = true
          }

          this.calculateQuantityCheckedMeals()
          this.getPortions(!this.entityId)
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      getServingSubcomponentNameById(id) {
        for (let i = 0; i < this.subcomponentsMeals.length; i++) {
          if (this.subcomponentsMeals[i].componentServingId === id) {
            return this.subcomponentsMeals[i].name
          }
        }
      },

    }
  })
}
